<template>
  <div class="wrapperlistCampaing mt-3">
    <header class="wrapperlistCampaing__header d-flex justify-content-between align-content-center px-4 py-3 bg-white">
      <h5 class="font-weight-normal">{{ titleList }}</h5>
      <CButton
        v-if="isNewCampaignBtnAvailable"
        style="margin-top: -22px"
        @click="$router.push({ name: 'campaign' })"
        color="primary"
        class="px-4 py-2 font-weight-bold"
      >
        {{ $t('home.campaign.newCampaign') }}
      </CButton>
    </header>
    <template v-if="loading">
      <div class="d-flex justify-content-center align-items-center mb-3 bg-white" style="height: 280px">
        <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
      </div>
    </template>
    <template v-else>
      <slot name="emptyList"></slot>
      <slot name="list"> </slot>
    </template>
    <div class="mt-5"></div>
    <div class="text-decoration text-uppercase position-bottom">
      <router-link v-if="textLinkList && linkList" :to="{ name: linkList }" tag="a" class="text-decoration text-gray-600 font-sm">{{
        textLinkList
      }}</router-link>
      <p class="m-0 ml-2 font-sm">{{ descriptionList }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wrapperListCampaign',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    titleList: {
      type: String,
      default: () => '',
    },
    linkList: {
      type: String,
      default: () => '',
    },
    textLinkList: {
      type: String,
      default: () => '',
    },
    descriptionList: {
      type: String,
      default: () => '',
    },
    isNewCampaignBtnAvailable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.wrapperlistCampaing {
  h6,
  a,
  p {
    line-height: inherit;
  }
  .wrapperlistCampaing__header {
    border-radius: 2px;
    box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.03);
    margin-bottom: 2px;
  }
}
.position-bottom {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 10px !important;
  margin-right: 25px !important;
}
</style>
